import React from 'react';
import config from '../config';
import DashboardInitializer from '../dashboards/DashboardInitializer';
import apiPaths from '../apiPaths';

const AnyoLectivoDashboard = (props) => {
  const components = [
    {
      params: {
        type: 'search',
        componentId: 'anyoLectivoanyoLectivoSearch',
        panelHeader: 'Año Lectivo ',
        panelKey: 'anyoLectivoanyoLectivoSearch',
        yPosition: 0,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: false,
        tabIndex: 0,
        tabTitle: '',
      },
      groups: [
        {
          index: 0,
          title: '',
          mustRender: true,
          subgroups: [
            {
              index: 0,
              title: '',
              mustRender: true,
              yPosition: 0,
              xPosition: 0,
              width: 24,
              fields: [
                {
                  key: 'anyoInicio',
                  yPosition: 1,
                  xPosition: 1,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'anyoFinal',
                  yPosition: 1,
                  xPosition: 2,
                  mustRender: true,
                  width: 8,
                },
                {
                  key: 'actual',
                  yPosition: 1,
                  xPosition: 3,
                  mustRender: true,
                  width: 8,
                },
              ],
            },
          ],
        },
      ],
      fields: [
        {
          title: 'Any Inici',
          key: 'anyoInicio',
          type: 'number',
          operand: 'like',
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Any Final',
          key: 'anyoFinal',
          type: 'number',
          operand: 'like',
          min: 0,
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Actual',
          key: 'actual',
          type: 'comboCustom',
          comboId: 'corporate',
          operand: 'like',
          min: 0,
          mandatory: false,
          disabled: false,
        },
      ],
      settings: {
        fieldSize: config.COMPONENT.FORM.FIELD_SIZE,
        fieldGutter: config.COMPONENT.FORM.FIELD_MARGIN,
      },
    },
    {
      params: {
        type: 'table',
        componentId: 'anyoLectivoanyoLectivoList',
        rowKey: 'id',
        panelHeader: 'Año Lectivo',
        panelKey: 'anyoLectivoanyoLectivoList',
        navigationParams: props.query.params.q || '',
        yPosition: 1,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: false,
        tabTitle: '',
        isMainTable: true,
        tabIndex: 0,
        tableType: 0,
      },
      fields: [
        {
          title: 'Id',
          dataIndex: 'id',
          position: 0,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          width: 60,
        },
        {
          title: 'Any Inici',
          dataIndex: 'anyoInicio',
          position: 1,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Any Final',
          dataIndex: 'anyoFinal',
          position: 2,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Nom',
          dataIndex: 'nombre',
          position: 3,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
        },
        {
          title: 'Actual',
          dataIndex: 'actual',
          position: 4,
          mustRender: true,
          align: 'left',
          sorter: true,
          visible: true,
          render: 'comboCustom',
          comboId: 'corporate',
        },
      ],
      settings: {
        size: config.COMPONENT.TABLE.SIZE,
        bordered: config.COMPONENT.TABLE.BORDERED,
        editable: true,
        multiple: false,
        canCreate: true,
        canDelete: true,
        scroll: { x: true },
      },
      pagination: {
        defaultPageSize: 50,
        pageSizeOptions: ['5', '10', '20', '50'],
        showQuickJumper: config.COMPONENT.SHOW_QUICK_JUMPER,
        showSizeChanger: config.COMPONENT.TABLE.SHOW_SIZE_CHANGER,
        showTotal: config.COMPONENT.TABLE.SHOW_TOTAL,
        size: config.COMPONENT.TABLE.SIZE,
      },
    },
    {
      params: {
        type: 'edit',
        componentId: 'anyoLectivoanyoLectivoEdit',
        panelHeader: 'Año Lectivo',
        panelKey: 'anyoLectivoanyoLectivoEdit',
        primaryKey: 'id',
        yPosition: 2,
        xPosition: 0,
        width: 24,
        collapsible: true,
        collapsed: false,
        isTabItem: true,
        tabIndex: 0,
        tabTitle: 'Año Lectivo',
      },
      groups: [
        {
          index: 0,
          title: '',
          mustRender: true,
          subgroups: [
            {
              index: 2,
              title: '',
              mustRender: true,
              yPosition: 0,
              xPosition: 0,
              width: 24,
              fields: [
                {
                  key: 'anyoInicio',
                  yPosition: 1,
                  xPosition: 1,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'anyoFinal',
                  yPosition: 1,
                  xPosition: 2,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'nombre',
                  yPosition: 2,
                  xPosition: 1,
                  mustRender: true,
                  width: 12,
                },
                {
                  key: 'actual',
                  yPosition: 2,
                  xPosition: 2,
                  mustRender: true,
                  width: 12,
                },
              ],
            },
          ],
        },
      ],
      fields: [
        {
          title: 'Any Inici',
          key: 'anyoInicio',
          type: 'number',
          unique: false,
          min: 0,
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Any Final',
          key: 'anyoFinal',
          type: 'number',
          unique: false,
          min: 0,
          mandatory: true,
          disabled: false,
        },
        {
          title: 'Nom',
          key: 'nombre',
          type: 'text',
          unique: false,
          min: 0,
          validationType: 'text',
          mandatory: false,
          disabled: false,
        },
        {
          title: 'Actual',
          key: 'actual',
          type: 'checkSelect',
          unique: false,
          min: 0,
          mandatory: true,
          disabled: false,
        },
      ],
      settings: {
        fieldSize: config.COMPONENT.FORM.FIELD_SIZE,
        fieldGutter: config.COMPONENT.FORM.FIELD_MARGIN,
        canEdit: true,
        canCreate: true,
        canDelete: true,
      },
    },
  ];

  const componentId = 'AnyoLectivoDashboard';

  return (
    <DashboardInitializer
      componentId={componentId}
      components={components}
      {...props}
    />
  );
};

export default AnyoLectivoDashboard;
